import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOldJoystick: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconOldJoystick"><Path d="M12 3C13.933 3 15.5 4.567 15.5 6.5C15.5 8.08536 14.4455 9.42311 13 9.85352V14H16V11H18V14H21V21H3V14H11V9.85352C9.55447 9.42311 8.5 8.08536 8.5 6.5C8.5 4.567 10.067 3 12 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOldJoystick;
